<script lang="ts">
	import Fa from 'svelte-fa';
	import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

	interface Props {
		icon: IconDefinition;
		title: string;
		description: string;
		/** Emphasis variant: gradient fill (flagship) vs bordered surface. */
		wide?: boolean;
	}

	let { icon, title, description, wide = false }: Props = $props();
</script>

<div
	class="group flex h-full flex-col items-start gap-5 rounded-3xl p-7 transition-transform duration-300 hover:-translate-y-1 {wide
		? 'bg-brand-gradient text-white'
		: 'card-bg-border card-border-tertiary'}"
>
	<Fa
		{icon}
		size="3x"
		class="transition-transform duration-300 group-hover:scale-105 {wide
			? 'text-white'
			: 'text-tertiary-500'}"
	/>
	<div class="text-2xl font-extrabold tracking-tight {wide ? 'sm:text-4xl' : 'sm:text-3xl'}">
		{title}
	</div>
	<p
		class="text-sm font-medium text-pretty sm:text-base {wide
			? 'text-white/90 sm:text-lg'
			: 'text-surface-800-200'}"
	>
		{description}
	</p>
</div>
